import { DependencyList, useEffect, useState } from 'react'

/**
 * Keeps the table in a loading state from first paint until `loading` has
 * finished at least once for the current dependency set.
 * Prevents the empty-state flash before the fetch effect runs.
 */
export function useTableLoadingGate(
  loading: boolean,
  deps: DependencyList = []
) {
  const depsKey = deps.map((d) => String(d ?? '')).join('|')
  const [armed, setArmed] = useState(true)
  const [seenKey, setSeenKey] = useState(depsKey)

  if (depsKey !== seenKey) {
    setSeenKey(depsKey)
    setArmed(true)
  }

  useEffect(() => {
    if (!loading) setArmed(false)
  }, [loading, depsKey])

  return armed || loading
}
